//alert types: success | failure
function notification(notice,alert_type) {
	$("body").append('<div class="alert alert-'+alert_type+' alert-dismissable"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>'+notice+'</div>');
	setTimeout(function(){ $("body").find(".alert").fadeOut(400, function(){ $(this).remove(); }) }, 8000 );
}